<template>
  <div>
    <div class="bg-white shadow-lg rounded-lg p-6 max-w-2xl mx-auto mt-8">
      <h1 class="text-xl font-medium text-gray-900 mb-4">
        Team inbox will be opened in a new tab, If it didn't open automatically,
      </h1>
      <button
        @click="openManually"
        class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded"
      >
        Click here to open
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApplyNumber",
  components: {},
  methods: {
    openManually() {
      this.$store.dispatch("getTeamInboxToken").then(response => {
        this.apiKey = response.token;
        window.open(`./#/teaminbox/${this.apiKey}`, "_blank");
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
